import * as React from 'react';
import type { TRelevantDocumentType } from '../../utils';
import DBSEffect from './DBSEffect';
import Levodopatest from './Levodopa';
import UPDRSIIIForm from './UPDRSIII';
import UPDRSVForm from './UPDRSV';
import FTMTRSForm from './FTMTRS';

const UPDRSForm = ({
  formData,
  document,
  documents,
  viewing = false,
  setSubDocuments,
}: IOwnProps): React.JSX.Element | null => {
  switch (document._type) {
    case 'updrs_iii':
      return <UPDRSIIIForm formData={formData} viewing={viewing} documents={documents} />;
    case 'updrs_v':
      return <UPDRSVForm formData={formData} viewing={viewing} />;
    case 'ftmtrs':
      return <FTMTRSForm formData={formData} viewing={viewing} />;
    case 'levodopatest':
      return (
        <Levodopatest formData={formData} documents={documents} viewing={viewing} setSubDocuments={setSubDocuments} />
      );
    case 'dbsEffect':
      return (
        <DBSEffect formData={formData} documents={documents} viewing={viewing} setSubDocuments={setSubDocuments} />
      );
    default:
      return null;
  }
};

interface IOwnProps {
  formData: IFormData;
  document: IDocumentWithTypeV2<TRelevantDocumentType>;
  documents: IDocumentWithTypeV2<'updrs_iii' | 'levodopatest' | 'dbsEffect' | 'updrs_v' | 'ftmtrs'>[];
  viewing?: boolean;
  setSubDocuments?: (subDocuments: { name: string; id: string }[]) => void;
}

export default UPDRSForm;
